var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_41",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "1.75px",
        },
        attrs: {
          d: "m57.953,26.51v-4.894c0-1.389,1.126-2.516,2.516-2.516h8.11c1.389,0,2.516,1.126,2.516,2.516v4.894",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "1.75px",
        },
        attrs: {
          d: "m64.506,44.183h-15.287l4.555,41.459c.212,1.926,1.839,3.385,3.777,3.385h13.911c1.938,0,3.565-1.458,3.777-3.384l4.555-41.459h-15.287Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "1.75px",
        },
        attrs: { x1: "50.532", y1: "56.138", x2: "78.48", y2: "56.138" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "1.75px",
        },
        attrs: {
          d: "m64.506,25.037c-8.615,0-15.599,6.984-15.599,15.599,0,1.179.131,2.328.379,3.433h30.428c.249-1.106.391-2.252.391-3.433,0-8.615-6.984-15.599-15.599-15.599Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "1.75px",
        },
        attrs: {
          d: "m47.576,67.098l-2.145,20.956c-.023.228-.216.402-.445.402h-16.496c-.229,0-.422-.174-.445-.402l-2.145-20.956c-.027-.264.18-.493.445-.493h20.786c.265,0,.472.229.445.493Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "1.75px",
        },
        attrs: { x1: "27.071", y1: "78.538", x2: "46.405", y2: "78.538" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }